import './paedml-modal.tag'
import './paedml-form-input.tag'
import './paedml-form-input-pw.tag'

<paedml-modal-create-domain>
  <paedml-modal prefix={opts.prefix} 
                heading={opts.heading} 
                opname={opts.opname} 
                edit={opts.edit} 
                selectedrowsfunc={opts.selectedrowsfunc} 
                idcol={opts.idcol} idtextcol={opts.idtextcol}
                submitfunc={submitHandler}>
  
    <yield to="fields">
      <div class="paedml-input-group">
        <div class="row">
          <div class="col-sm-12">
            <paedml-form-input name="domain" col="1" label="Name der externen Domäne"
              required data-msg="Bitte geben Sie den Namen der externen Domäne ein"
              data-rule-domain data-msg-domain='Geben Sie bitte einen gültigen Namen für Domäne ein'
            />
            <svg if={parent.isChecking} class="paedml-icon-overlay fullrotation">
              <use xlink:href="#far-question-circle" />
            </svg>
          </div>
        </div>
      </div>

    </yield>
  </paedml-modal>
    
    <script>
      import { handleSubmitCreateOrEdit, domainAvailable, clearDomainAvailabilityCtx } from '../util/api-util'
      import * as R from 'ramda'
      
      this.opname = this.opts.opname
      this.data = {}
      this.api = this.opts.api

      this.submitHandler = formData => {
        return this.api.create(formData).then(rsp => {
          const [data, status] = rsp
          if (status.success) {
            this.parent.trigger('reloadTable')
            return `Externe Domäne "${formData.domain}" erfolgreich hinzugefügt.`
          }

          return Promise.reject(`Externe Domäne "${formData.domain}" konnte nicht hinzugefügt werden.`)
        })
      }
    </script>
</paedml-modal-create-domain>
